import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'all_companies_tab/FETCH_REQUEST'
const FETCH_SUCCESS = 'all_companies_tab/FETCH_SUCCESS'
const FETCH_FAILURE = 'all_companies_tab/FETCH_FAILURE'
const FETCH_FILTER_REQUEST = 'all_companies_tab/FETCH_FILTER_REQUEST'
const FETCH_FILTER_SUCCESS = 'all_companies_tab/FETCH_FILTER_SUCCESS'
const FETCH_FILTER_FAILURE = 'all_companies_tab/FETCH_FILTER_FAILURE'
const DOWNLOAD_SUCCESS = 'all_companies_tab/DOWNLOAD_SUCCESS'

const initialState = {
    result: { results: [], result: [] },
    loaded: false,
    loading: false,
    allResult: {},
    filterLoaded: false,
    filterLoading: false,
    errors: []
}

export function fetchRequest(payload = {}) {
    return {
        type: FETCH_REQUEST,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors = []) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}


export function fetchFilterRequest(payload = {}) {
    return {
        type: FETCH_FILTER_REQUEST,
    }
}

export function fetchFilterSuccess(payload) {
    return {
        type: FETCH_FILTER_SUCCESS,
        payload,
    }
}

export function downloadSuccess() {
    return {
        type: DOWNLOAD_SUCCESS
    }
}

export function fetchFilterFailure(errors = []) {
    return {
        type: FETCH_FILTER_FAILURE,
        errors,
    }
}

export function loadAllListData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise1 = api('api/v1/listed_organisations/options', {}, {}, true);

        const promise2 = api('api/v1/listed_organisations/list', options, {}, true);

        Promise.all([promise1, promise2])
            .then(responses => Promise.all(responses.map(response => response.json())))
            .then(data => {
                const mergedJson = Object.assign({}, ...data); // Merging JSON objects
                console.log('Merged JSON:', mergedJson);
                dispatch(fetchSuccess(mergedJson));
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })  
            })

        return [promise1, promise2]
    }
}

export function loadAllListFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())
        const promise = api('api/v1/listed_organisations/list/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }

            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))
                })
            })

        return promise
    }
}

export function loadAllCompaniesData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise1 = api('api/v1/listed_organisations/options', {}, {}, true);

        const promise2 = api('api/v1/listed_organisations/all_entities', options, {}, true);

        Promise.all([promise1, promise2])
            .then(responses => Promise.all(responses.map(response => response.json())))
            .then(data => {
                const mergedJson = Object.assign({}, ...data); // Merging JSON objects
                console.log('Merged JSON:', mergedJson);
                dispatch(fetchSuccess(mergedJson));
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })  
            })

        return [promise1, promise2]
    }
}

export function loadAllCompaniesFilterData(options) {
    return (dispatch) => {
        dispatch(fetchFilterRequest())
        const promise = api('api/v1/listed_organisations/all_entities/', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                if (options['all']) {
                    dispatch(downloadSuccess())
                    toastr["success"](json['message']);
                } else {
                    dispatch(fetchFilterSuccess(json))
                }

            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFilterFailure(errors))
                })
            })

        return promise
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action

    switch (type) {
        case DOWNLOAD_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: []
            })
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true,
            })
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors,
            })
        case FETCH_FILTER_REQUEST:
            return Object.assign({}, state, {
                filterLoading: true,
            })
        case FETCH_FILTER_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: [],
                result: { option: state.result.option, ...payload }
            })
        case FETCH_FILTER_FAILURE:
            return Object.assign({}, state, {
                filterLoaded: false,
                filterLoading: false,
                errors,
            })
        default:
            return state
    }
}
